import React from 'react';
import axios from 'axios';

import * as Globals from './../Globals';


export default class QuestionCreator extends React.Component {

	constructor(props) {
		super(props);

        this.subjectID = this.props.subjectID;
        this.questionID = -1;
		this.state = {
            text: "",
            explanation: "",
            answers: [],
            image: "",
            errorMessage: "",
            saving: false
		}
	}

    handleExplanationChange(event) {
        this.setState({
            explanation: event.target.value
        });
    }
    handleTextChange(event) {
        this.setState({
            text: event.target.value
        });
    }
	saveQuestion() {
        if (this.state.answers.length === 0) {
            this.setState({
                errorMessage: "Es muss mindestens eine Antwort angegeben werden."
            });
            return null;
        }
        let minOneChecked = false;
        this.state.answers.map(answer => {
            if (answer.checked) {
                minOneChecked = true;
            }
            return null;
        });
        if (this.state.text === "") {
            this.setState({
                errorMessage: "Sie müssen einen Fragentext eingeben."
            });
            return null;
        }
        let isAnswerTextNull = false;
        this.state.answers.map(answer => {
            if (answer.text === "") {
                isAnswerTextNull = true;
            }
            return null;
        });
        if (isAnswerTextNull) {
            this.setState({
                errorMessage: "Sie müssen bei jeder Antwort einen Text angeben."
            });
            return null;
        }
        if (!minOneChecked) {
            this.setState({
                errorMessage: "Mindestens eine Antwort muss \"Richtig\" sein."
            });
            return null;
        }
        let cookie = this.props.LogoutOnCookieNotSet();
        this.setState({ saving: true });
        axios.post(Globals.EL_PATH + 'subject/' + this.subjectID + '/question?Authentication=' + cookie, {
            "TEXT": this.state.text,
            "ANSWER_EXPLANATION": this.state.explanation
        }).then(response => {
            this.questionID = response.data.question_id;
            let count = 0;
            if (this.state.image !== "") {
                let formData = new FormData();
                formData.append('file', this.state.image);
                axios.post(Globals.EL_PATH + 'question/' + this.questionID + '/picture?Authentication=' + cookie, formData,
                {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                }).then(response => {
                }).catch((error) => {
                    this.props.CheckAuthError(error);
                });
            }
            this.state.answers.map( (answer) => {
            axios.post(Globals.EL_PATH + 'question/' + this.questionID + '/answer?Authentication=' + cookie, {
                "TEXT": answer.text,
                "IS_TRUE": answer.checked
            }).then(response => {
                count++;
                if (count === this.state.answers.length) {
                    this.props.sendCloseCreator(true);
                }
            }).catch((error) => {
                this.props.CheckAuthError(error);
            });
            return null;
            });
		}).catch((error) => {
			this.props.CheckAuthError(error);
        });
    }
    deleteAnswer(index) {
        let answers = [];
        this.state.answers.map( (answer ,i) => {
            if (i !== index) {
                answers.push(answer);
            }
            return null;
        });
        this.setState({
            answers: answers
         });
    }
    handleCheckedChange(index) {
        const answers = this.state.answers;
        answers[index].checked = !answers[index].checked;

        this.setState({
            answers: answers
        });
    }
    handleAnswerTextChange(e, index) {
        const answers = this.state.answers;
        answers[index].text = e.target.value;

        this.setState({
            answers: answers
        });
    }
    addAnswer() {
        const answers = this.state.answers.slice();
        answers.push({checked: false, text: ""})
        this.setState({ answers: answers })
    }

    getErrorMessage() {
        if (this.state.errorMessage !== "") {
            return (
                <div className="alert alert-danger text-center margin-bottom-sm"><b>{ this.state.errorMessage }</b></div>
            );
        }
        return null;
    }

    render(){
		return (
            <div>
                <form onSubmit={ () => this.saveQuestion() }>
                    <div className="well well-sm">
                        <div className="form-group">
                            <label>Fragentext</label>
                            <input type="text" className="form-control" value={ this.state.text } onChange={ (e) => this.handleTextChange(e) }/>
                        </div>
                        <div className="form-group">
                            <label>Erklärung</label>
                            <input type="text" className="form-control" value={ this.state.explanation } onChange={ (e) => this.handleExplanationChange(e) }/>
                        </div>
                        <label>Antworten</label>
                        <p style={{color: "#999999"}}>Antworten, die richtig sind, ankreuzen</p>
                        {
                            this.state.answers.map( (answer, index) => {
                                return (
                                    <div key={index} className="input-group margin-bottom-sm">
                                        <label className="checkbox-label input-group-addon" style={{marginRight: '0', lineHeight: '22px'}}>
                                            <input className="customCheckbox" type="checkbox" checked={ answer.checked } onChange={ () => this.handleCheckedChange(index) } />
                                            <span className="label-text"/>
                                        </label>
                                        <input type="text"  value={ answer.text } onChange={ (e) => this.handleAnswerTextChange(e, index) } className="form-control"/>
                                        <span className="input-group-addon glyphicon glyphicon glyphicon-trash removeQuestion" onClick={ () => this.deleteAnswer(index)}></span>
                                    </div>
                                );
                            })
                        }
                        <button className="btn btn-default center-block" type="button" onClick={ () => this.addAnswer() }>Antwort hinzufügen</button>
                        <label>Bild</label>
                        <input type="file" accept="image/*" name="file" onChange={ (e) => this.setState({ image: e.target.files[0] }) }/>
                    </div>
                    { this.getErrorMessage() }
                    {
                        (this.state.saving) ?
                        <button className="btn btn-success center-block float-right creatorButtons firstCreatorButton" type="button" disabled>Frage erstellen</button> :
                        <button className="btn btn-success center-block float-right creatorButtons firstCreatorButton" type="button" onClick={ () => this.saveQuestion() }>Frage erstellen</button>
                    }
                    <button className="btn btn-danger center-block float-left creatorButtons secondCreatorButton" type="button" onClick={ () => this.props.sendCloseCreator(false) }>Abbrechen</button>
                </form>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/admin/QuestionCreator.js